module.exports = __webpack_public_path__ + "static/media/other-category.1ea183a4.png";